export default __webpack_public_path__ + "static/media/AreaField.90bdfe9d.svg";